// extracted by mini-css-extract-plugin
module.exports = {"subdescription":"PagePresentation_subdescription__3Xr6n","frameText":"PagePresentation_frameText__p9C4V","link":"PagePresentation_link__3DvNv"};